var Base58 = require('base-58');
var secp256k1 = require('secp256k1');

/**
 * Verify the already-hashed Saito transaction signing payload.
 *
 * app.crypto.verifySignature cannot be used here: that public helper hashes
 * its input before verification, while getHashForSignature() already returns
 * the transaction hash. Passing that value through the helper would verify a
 * double hash and reject valid transactions.
 */
function verifyTransactionSignatureHash(tx, signer) {
  if (!(tx !== null && tx !== void 0 && tx.signature) || !signer || typeof tx.getHashForSignature !== 'function') return false;
  if (typeof tx.generateHashForSignature === 'function') tx.generateHashForSignature();
  var hash = tx.getHashForSignature();
  if (!(hash instanceof Uint8Array) || hash.length !== 32) return false;
  var signingHash = Buffer.from(hash);
  var signature = Buffer.from(String(tx.signature), 'hex');
  var publicKey = Buffer.from(Base58.decode(String(signer)));
  if (signature.length !== 64 || publicKey.length !== 33) return false;
  return secp256k1.verify(signingHash, signature, publicKey);
}
module.exports = {
  verifyTransactionSignatureHash: verifyTransactionSignatureHash
};